import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { RatingsAndLipsOrUnderarmDivider } from '../components/dividers/RatingsAndLipsOrUnderarmDivider.builder';
Builder.registerComponent(RatingsAndLipsOrUnderarmDivider, {
    name: BUILDER_DIVIDER_NAMES.RatingsAndLipsOrUnderarmDivider,
});
